import React from 'react';
import { motion } from 'framer-motion';
import { Target, TrendingUp, Clock, EyeOff, Settings, CheckSquare } from 'lucide-react';
export function DiscoverSection() {
  const discoveries = [{
    icon: <Clock className="w-6 h-6 text-blue-500" data-id="element-40" />,
    title: 'El error más común',
    description: 'El error más común que destruye campañas: mover anuncios antes de tiempo (y qué ventana mínima respetar).'
  }, {
    icon: <TrendingUp className="w-6 h-6 text-blue-500" data-id="element-41" />,
    title: 'La trampa del presupuesto',
    description: 'Cómo manejar el presupuesto sin "romper" el rendimiento.'
  }, {
    icon: <Target className="w-6 h-6 text-blue-500" data-id="element-42" />,
    title: 'Fase de aprendizaje',
    description: 'Qué significa realmente "dejar aprender" y cómo saber si estás en fase de aprendizaje o estancamiento.'
  }, {
    icon: <EyeOff className="w-6 h-6 text-blue-500" data-id="element-43" />,
    title: 'Audiencias silenciosas',
    description: 'Cuándo NO debes apagar audiencias o conjuntos "silenciosos" (y por qué esos datos importan).'
  }, {
    icon: <Settings className="w-6 h-6 text-blue-500" data-id="element-44" />,
    title: 'Reducir intervención',
    description: 'Cómo reducir la intervención para que Andrómeda trabaje mejor: menos cambios, más señales útiles.'
  }, {
    icon: <CheckSquare className="w-6 h-6 text-blue-500" data-id="element-45" />,
    title: 'Checklist simple',
    description: 'Un checklist simple para revisar tu cuenta sin entrar en pánico ni tocar botones por impulso.'
  }];
  return <section className="py-20 px-4 bg-[#0d0d14]" data-id="element-46">
      <div className="max-w-5xl mx-auto" data-id="element-47">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-48">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-49">
            ¿Qué vas a descubrir dentro?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-50">
          {discoveries.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-[#15151e] border border-gray-800 rounded-xl p-6 hover:border-blue-500/50 transition-colors duration-300" data-id="element-51">
              <div className="w-12 h-12 bg-blue-500/10 rounded-lg flex items-center justify-center mb-4" data-id="element-52">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-53">
                {item.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-54">
                {item.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}